/**
 * Safe language allowlist for react-syntax-highlighter (Prism).
 *
 * SECURITY: This list intentionally excludes languages with known ReDoS
 * vulnerabilities such as SCSS (SONATYPE-2020-1579). Any language not in
 * this list is silently demoted to "text" so that unrecognised or
 * attacker-controlled language tags cannot trigger a catastrophic backtrack.
 *
 * When adding new languages, verify the Prism grammar does not contain
 * unbounded quantifier chains before appending.
 */
export const SAFE_SYNTAX_LANGUAGES = [
  "javascript",
  "jsx",
  "typescript",
  "tsx",
  "python",
  "json",
  "yaml",
  "bash",
  "shell",
  "sql",
  "html",
  "css",
  "xml",
  "markdown",
  "text",
  "plaintext",
];

export const FALLBACK_SYNTAX_LANGUAGE = "text";

const SAFE_SYNTAX_LANGUAGE_SET = new Set(SAFE_SYNTAX_LANGUAGES);

export const isSafeSyntaxLanguage = (language) =>
  typeof language === "string" &&
  SAFE_SYNTAX_LANGUAGE_SET.has(language.toLowerCase());

/**
 * Returns the language if it is allowlisted, otherwise the plain-text fallback.
 */
export const getSafeSyntaxLanguage = (language) =>
  isSafeSyntaxLanguage(language)
    ? language.toLowerCase()
    : FALLBACK_SYNTAX_LANGUAGE;
